















import Vue from 'vue'
import { mapState } from 'vuex'
import { State, Action, Getter } from 'vuex-class'
import Component from 'vue-class-component'
import { User } from '@/store/context/contextTypes'
import { maskValue } from '@/utils/helpers'
import JavascriptAPI from '@/utils/JavascriptAPI'

// Vuex + typescript setup guide: https://codeburst.io/vuex-and-typescript-3427ba78cfa8
@Component({
  props: {
    userInfo: { type: Object, required: true },
    editMethod: { type: Function, required: false, default: () => {} },
    overviewIcon: { type: String, required: false, default: null }
  }
})
export default class IdentityWizard extends Vue {
  userInfo: User

  mounted () {
    setTimeout(() => {
      JavascriptAPI.__REPORT_CLIENT_HEIGHT__()
    }, 50)
  }

  get userFullName () {
    return `${this.userInfo.firstName} ${this.userInfo.lastName}`
  }
  get nationalId () {
    try {
      return maskValue(this.userInfo.nationalId, 6)
    } catch (err) {
      return ''
    }
  }
  get address () {
    return `${maskValue(this.userInfo.address1, this.userInfo.address1.length, 2)}, ${this.userInfo.zip}, ${this.userInfo.city}`
  }
  get phonenumber () {
    try {
      return maskValue(this.userInfo.phonenumber, 4, 4)
    } catch (err) {
      return ''
    }
  }
}
